import { render, staticRenderFns } from "./HardCover.vue?vue&type=template&id=8b95e17e&scoped=true&lang=pug&"
import script from "./HardCover.vue?vue&type=script&lang=js&"
export * from "./HardCover.vue?vue&type=script&lang=js&"
import style0 from "./HardCover.vue?vue&type=style&index=0&id=8b95e17e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95e17e",
  null
  
)

export default component.exports